import { useCallback } from 'react';

export const usePrint = (temporaryTitle: string): { print: () => void } => {
  const print = useCallback(() => {
    const originalTitle = document.title;

    const handleBeforePrint = () => {
      document.title = temporaryTitle;
    };

    const handleAfterPrint = () => {
      document.title = originalTitle;
    };

    globalThis.addEventListener('beforeprint', handleBeforePrint);
    globalThis.addEventListener('afterprint', handleAfterPrint);

    globalThis.print();

    globalThis.removeEventListener('beforeprint', handleBeforePrint);
    globalThis.removeEventListener('afterprint', handleAfterPrint);
  }, [temporaryTitle]);

  return { print };
};
